import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./UserSurveyManagement.css";
import TableComponent from "../../common/TableComponent/TableComponent";
import { getUserSurveys } from "../../../services/survey/survey-user";
import Loader from "../../common/Loader/Loader";
import { DataTableComponent } from "../../common/TableComponent/DataTableComponent";
import { formatDate } from "../../../utils/dateFormat";
import { useTranslation } from "react-i18next";

const UserSurveyManagement = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  // const userEmail = localStorage.getItem("userEmail");
  const { t, i18n } = useTranslation();

  const columns = [
    { name: t('surveyTitle'), field: "surveyTitle", sortable: true, selector: row => row.surveyTitle },
    // { name: "Submitted Date", field: "submittedDate", sortable: true, selector: row => row.submittedDate },
    { name: t('startDate'), field: "startDate", sortable: true, selector: row => row.startDate },
    {
      name: t('endDate'), field: "endDate", sortable: true, selector: row => row.endDate, id: "endDate",
      sortFunction: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    { name: t('description'), field: "description", sortable: true, selector: row => row.description },
  ];

  useEffect(() => {
    const loadSurveys = async () => {
      setLoading(true);
      try {
        const languageDetails = JSON.parse(sessionStorage.getItem("selectedLanguageDetails") || "{}");
        let languageId = 1;
        if(i18n.language === languageDetails.name){
          languageId = languageDetails.id || 1;
        }
        // const languageId = languageDetails.id || 1;
        
        const response = await getUserSurveys(languageId);
        if (response.statusCode === 200 && response.data) {
          const filteredData = response?.data.filter(survey => 
            survey.languageMasterId === languageId
          );
          setData(filteredData);
          setLoading(false);
        } else {
          console.error("Unexpected API response:", response);
          setLoading(false);
        }
      } catch (error) {
        console.error("Failed to fetch surveys:", error);
        setLoading(false);
      }
    };

    loadSurveys();
  }, [i18n.language]);

  useEffect(() => {
    sessionStorage.setItem("isUserSurveysQuePageOpen", 'false');
    const event = new Event('sessionStorageUpdated1');
    window.dispatchEvent(event);
  },[])

  const onViewDoc = (rowData) => {
    navigate("/user/survey/opening-page", { state: rowData });
  }

  return (
    <>
      {loading && <Loader />}
      <div className="userMangementTable">
        <div>
          <div className="userMangementTable-tableContain">
            <DataTableComponent columns={columns} data={data} onViewDoc={onViewDoc} tableName="userSurvey" isAscendingOrder={true} />
          </div>
        </div>
      </div>

    </>
  );
};

export default UserSurveyManagement;